/**
 * Object defining needed properties of a navigation item.
 * 
 * - title: Used to get the correct translation for the item.
 * - nav: Used as the route of the item.
 * - children: Used if the item has sub-routes available.
 */
export interface NavItem {
    title: string,
    nav?: string,
    goTo?: string,
    children?: NavItem[],
    /** Renders the item as a highlighted pill to make it stand out in the menus. */
    highlight?: boolean
}

/**
 * NavItem for consulting section and childrens, will be used on the navigationItems constant.
 */
export const consultingItem: NavItem = {
    title: 'Services',
    nav: 'services',
    children: [
        {
            title: 'Information Management',
            nav: 'services/info-management'
        }, {
            title: 'Capacity Building & Trainings',
            nav: 'services/training-and-capacity'
        }, {
            title: 'MEAL and Research',
            nav: 'services/meal-and-research'
        }, {
            title: 'Mobile, Web Dev & Maintenance',
            nav: 'services/app-dev-and-maintenance'
        }, {
            title: 'AI & Interactive tools',
            nav: 'services/AI-and-tools'
        }, {
            title: 'Engagement Strategy',
            nav: 'services/engagement-strategies'
        }, {
            title: 'Privacy & Cybersecurity',
            nav: 'services/privacy-cybersecurity'
        }
    ]
};

/**
 * NavItem array of available routes used on navigation components.
 */
export const navigationItems: NavItem[] = [
    {
        title: 'Home',
        nav: 'home'
    },
    {
        title: 'Services',
        nav: 'services',
    },
    {
        title: 'Relief Apps',
        nav: 'relief-apps',
        children: [
            {
                title: 'Your Custom App',
                nav: 'custom'
            }, {
                title: 'Warehouse & Stock',
                nav: 'suites/warehouse-and-stock-management-system'
            }, {
                title: 'Case Management',
                nav: 'suites/case-management-system'
            }, {
                title: 'Monitoring & Evaluation',
                nav: 'suites/monitoring-and-evaluation-management-system'
            }
        ]
    }, {
        title: 'Portfolio',
        nav: 'projects'
    }, {
        title: 'About',
        nav: 'about',
        children: [
            /**{
                title: getTranslationKeyForNavigation('about', 'reliefApplications'),
                nav: 'about'
            }, **/{
                title: 'Our Commitment',
                nav: 'commitment'
            }, {
                title: 'Career',
                nav: 'career'
            }
        ]
     },
    {
        title: 'Partners',
        nav: 'partners'
    },
    {
        title: 'DP4G',
        nav: 'dp4g',
        highlight: true
    }
]